import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-general-dialog',
    templateUrl: './general-dialog.component.html',
    styleUrls: ['./general-dialog.component.scss'],
    standalone: false,
})
export class GeneralDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<GeneralDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}
}
